import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import Image from '../../Image/Image';
import ImageHotSpot from './ImageHotSpot';
import useStyles from './ShoppableImage.styles';
import ImageContainer from '../../ContentFeature/ImageContainer/ImageContainer';
import clsx from 'clsx';
import { useTheme } from '@mui/material';
const ShoppableImage = (props) => {
    var _a, _b;
    const { image, hotspots, mobileImage } = props;
    const [showImageHotspots, setShowImageHotspots] = useState(true);
    const theme = useTheme();
    const handleResize = useCallback(() => {
        if (typeof window !== 'undefined' && window.innerWidth < theme.breakpoints.values.sm && (mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.url)) {
            setShowImageHotspots(false);
        }
        else {
            setShowImageHotspots(true);
        }
    }, [mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.url, (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.sm]);
    useEffect(() => {
        handleResize();
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }
    }, [handleResize]);
    const { classes } = useStyles();
    return (_jsxs(_Fragment, { children: [(image === null || image === void 0 ? void 0 : image.url) && (_jsxs("div", { className: clsx(classes.shoppableImage, !(mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.url) && classes.displayDesktopImage, classes.desktopImage), "data-testid": "shoppable-image", children: [_jsx(Image, { imageUrl: (image === null || image === void 0 ? void 0 : image.url) || '', altText: (image === null || image === void 0 ? void 0 : image.altText) || '', loading: "lazy" }), showImageHotspots && (hotspots === null || hotspots === void 0 ? void 0 : hotspots.length) && (_jsx(ImageHotSpot, { hotspots: hotspots !== null && hotspots !== void 0 ? hotspots : [], mobileImage: mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.url }))] })), (mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.url) && (_jsx("div", { className: classes.mobileImage, "data-testid": "mobile-image", children: _jsx(ImageContainer, { mobileImage: mobileImage, squareImage: true }) }))] }));
};
export default ShoppableImage;
